import { AD, EP, GLOBAL_CONTEXT, USER_TYPE_COOKIE_NAME } from "mmbclient/Common/CommonVariable";
import { useContext } from "react";
import CircularSpinner from "mmbclient/Components/CircularSpinner";
import TrackingController from "./TrackingController";
import { getCookie } from "mmbclient/Common/CommonFunctions";
import "./Tracking.css";

export const Tracking = () => {


    const store = useContext(GLOBAL_CONTEXT);

    const { formValues, handleInputChange, loading, modalMessage, modalType, showModal, setShowModal, betterLoggerFunction, handleSearch, handleReset, error, objectURL, handleClick } = TrackingController(store);

    return (
        <>
            {/* Bootstrap Modal */}
            <div className={`modal fade ${showModal ? 'show' : ''}`} style={{ display: showModal ? 'block' : 'none' }} tabIndex="-1" role="dialog" aria-labelledby="modalLabel" aria-hidden={!showModal}>
                <div className="modal-dialog" role="document">
                    <div className="modal-content">
                        {/* <div className={`modal-header alert-${modalType}`}> */}
                        <div className={`modal-header alert-${modalType} d-flex justify-content-between`}>
                            <h5 className="modal-title" id="modalLabel">Alert</h5>
                            <button type="button" className="close" onClick={() => setShowModal(false)} aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            {modalMessage}
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-secondary" onClick={() => setShowModal(false)}>
                                Close
                            </button>
                        </div>
                    </div>
                </div>
            </div>


            <div onMouseOver={betterLoggerFunction}>
                {loading && <CircularSpinner />}
                {/* Body Content */}
                <div className="container mt-2">
                    <div className="text-center">
                        <h1 style={{fontSize:'20px'}}>Tracking</h1>
                    </div>
                    <section className="border p-3 mb-2">
                        <form>
                            <div className="row mb-3 align-items-end"> {/* Adjust row alignment */}
                                <div className="col-md-3"> {/* Adjust column width */}
                                    <label className="form-label small-label">Select</label>
                                    <div className="d-flex">
                                        <div className="form-check form-check-inline small-label">
                                            <input
                                                type="radio"
                                                id="rdBtnAwbNo"
                                                name="rdBtnAwbNo"
                                                value="rdBtnAwbNo"
                                                className="form-check-input small-label"
                                                checked={formValues.searchType === true}
                                                onChange={handleInputChange}
                                            />
                                            <label htmlFor="rdBtnAwbNo" className="form-check-label small-label">Awb No.&nbsp;&nbsp;&nbsp;&nbsp;</label>
                                        </div>
                                        <div className="form-check form-check-inline">
                                            <input
                                                type="radio"
                                                id="rdBtnFwdNo"
                                                name="rdBtnFwdNo"
                                                value="rdBtnFwdNo"
                                                className="form-check-input small-label"
                                                checked={formValues.searchType === false}
                                                onChange={handleInputChange}
                                            />
                                            <label htmlFor="rdBtnFwdNo" className="form-check-label small-label">Fwd No.</label>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-2"> {/* Adjust column width */}
                                    {formValues.searchType === true ? (
                                        <>
                                            <label className="form-label small-label">Awb No.</label>
                                            <input
                                                type="text"
                                                name="awbNo"
                                                className="form-control small-input"
                                                placeholder="Awb No."
                                                value={formValues.awbNo}
                                                onChange={handleInputChange}
                                            />
                                        </>
                                    ) : (
                                        <>
                                            <label className="form-label small-label">Fwd No.</label>
                                            <input
                                                type="text"
                                                name="fwdNo"
                                                className="form-control small-input"
                                                placeholder="Fwd No."
                                                value={formValues.fwdNo}
                                                onChange={handleInputChange}
                                            />
                                        </>
                                    )}
                                </div>
                                <div className="col-md-2 d-flex justify-content-start align-items-center"> {/* Added flex for horizontal alignment */}
                                    <button
                                        type="button"
                                        className="btn btn-primary mt-2 me-2 small-input"
                                        onClick={handleSearch}
                                    >
                                        Search
                                    </button>
                                    <button
                                        type="button"
                                        className="btn btn-secondary mt-2 small-input"
                                        onClick={handleReset}
                                    >
                                        Reset
                                    </button>
                                </div>
                            </div>
                            <hr class="my-2" />
                            {(objectURL || error) && (
                                <div className="row mb-3 align-items-center">
                                    <div className="col-md-2">
                                        <a 
                                            href="javascript:void(0)" 
                                            onClick={handleClick} 
                                            className="mt-3 d-block" 
                                            style={{ cursor: 'pointer', color: 'blue', textDecoration: 'underline' }}>
                                            Print Shipper
                                        </a>
                                    </div>
                                </div>
                            )}
                            {
                                (getCookie(USER_TYPE_COOKIE_NAME) === AD || getCookie(USER_TYPE_COOKIE_NAME) === EP) ?
                                    <>
                                        <div className="row mb-3 align-items-center">
                                            <div className="col-md-6">
                                                <label className="form-label small-label">Client</label>
                                                <input
                                                    type="text"
                                                    name="client"
                                                    className="form-control small-input"
                                                    placeholder="client"
                                                    value={formValues.client}
                                                    readOnly
                                                />
                                            </div>
                                        </div>
                                    </> : null
                            }
                            <div className="row mb-3 align-items-center">
                                <div className="col-md-2">
                                    <label className="form-label small-label">Booking Date</label>
                                    <input
                                        type="text"
                                        name="bookingDate"
                                        className="form-control small-input"
                                        placeholder="booking date"
                                        value={formValues.bookingDate}
                                        readOnly
                                    />
                                </div>
                                <div className="col-md-2">
                                    <label className="form-label small-label">Service</label>
                                    <input
                                        type="text"
                                        name="service"
                                        className="form-control small-input"
                                        placeholder="service"
                                        value={formValues.service}
                                        readOnly
                                    />
                                </div>
                                <div className="col-md-2">
                                    <label className="form-label small-label">Packets</label>
                                    <input
                                        type="text"
                                        name="packets"
                                        className="form-control small-input"
                                        placeholder="packets"
                                        value={formValues.pkt}
                                        readOnly
                                    />
                                </div>
                                {/* <div className="col-md-1">
                                    <label className="form-label">Weight</label>
                                    <input
                                        type="text"
                                        name="billingWt"
                                        className="form-control"
                                        placeholder="weight"
                                        value={formValues.billingWt}
                                        readOnly
                                    />
                                </div> */}
                                <div className="col-md-4">
                                    <label className="form-label small-label">Destination</label>
                                    <input
                                        type="text"
                                        name="destination"
                                        className="form-control small-input"
                                        placeholder="destination"
                                        value={formValues.destination}
                                        readOnly
                                    />
                                </div>
                                <div className="col-md-2">
                                    <label className="form-label small-label">Invoice No.</label>
                                    <input
                                        type="text"
                                        name="invoiceNo"
                                        className="form-control small-input"
                                        placeholder="invoice no."
                                        value={formValues.invoiceNo}
                                        readOnly
                                    />
                                </div>
                            </div>
                            <div className="row mb-3 align-items-center">
                                <div className="col-md-4">
                                    <label className="form-label small-label">Consignor Name</label>
                                    <input
                                        type="text"
                                        name="consignorName"
                                        className="form-control small-input"
                                        placeholder="consignor name"
                                        value={formValues.consignorName}
                                        readOnly
                                    />
                                </div>
                                <div className="col-md-2">
                                    <label className="form-label small-label">Consignor Phone</label>
                                    <input
                                        type="text"
                                        name="consignorPhone"
                                        className="form-control small-input"
                                        placeholder="consignor phone"
                                        value={formValues.consignorPhone}
                                        readOnly
                                    />
                                </div>
                                <div className="col-md-4">
                                    <label className="form-label small-label">Consignee Name</label>
                                    <input
                                        type="text"
                                        name="consigneeName"
                                        className="form-control small-input"
                                        placeholder="consignee name"
                                        value={formValues.consigneeName}
                                        readOnly
                                    />
                                </div>
                                <div className="col-md-2">
                                    <label className="form-label small-label">Consignee Phone</label>
                                    <input
                                        type="text"
                                        name="consigneePhone"
                                        className="form-control small-input"
                                        placeholder="consignee phone"
                                        value={formValues.consigneePhone}
                                        readOnly
                                    />
                                </div>
                            </div>
                            <div className="row mb-3 align-items-center">
                                <div className="col-md-2">
                                    <label className="form-label small-label">Delivery Date</label>
                                    <input
                                        type="text"
                                        name="deliveryDate"
                                        className="form-control small-input"
                                        placeholder="delivery date"
                                        value={formValues.deliveryDate}
                                        readOnly
                                    />
                                </div>
                                <div className="col-md-2">
                                    <label className="form-label small-label">Delivery Status</label>
                                    <input
                                        type="text"
                                        name="deliveryStatus"
                                        className="form-control small-input"
                                        placeholder="delivery status"
                                        value={formValues.deliveryStatus}
                                        readOnly
                                    />
                                </div>
                                <div className="col-md-4">
                                    <label className="form-label small-label">Received By</label>
                                    <input
                                        type="text"
                                        name="receivedBy"
                                        className="form-control small-input"
                                        placeholder="received by"
                                        value={formValues.receivedBy}
                                        readOnly
                                    />
                                </div>
                                <div className="col-md-4">
                                    <label className="form-label small-label">Remarks</label>
                                    <input
                                        type="text"
                                        name="remarks"
                                        className="form-control small-input"
                                        placeholder="remarks"
                                        value={formValues.remarks}
                                        readOnly
                                    />
                                </div>
                                <div className="col-md-2">

                                </div>
                                <div className="col-md-2">

                                </div>
                            </div>
                        </form>
                    </section>
                </div>

                {/* Footer */}
                {/* <footer className="bg-light text-center py-3">
                <div className="container">
                    <span>© 2024 My Application. All Rights Reserved.</span>
                </div>
                </footer> */}
            </div >
        </>
    );

}